import { FeatureType, Menu, MenuType } from "./menu-item-shared";

export const autoExportMenu: Menu = {
  state: 'autoexport',
  name: 'menu.autoexport',
  icon: 'cloud_download',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.AutoExport],
};
